import { create } from 'zustand';

interface ReportProblemState {
  isOpen: boolean;
  /** Pre-filled when the dialog is opened by an automatic error capture. */
  prefill: { title?: string; errorStack?: string } | null;
  open: (prefill?: { title?: string; errorStack?: string }) => void;
  close: () => void;
}

/**
 * The dialog is mounted once at the app root and opened from anywhere — the user menu, a
 * 3D toolbar, or an error boundary — without threading props through every layout.
 */
export const useReportProblemStore = create<ReportProblemState>((set) => ({
  isOpen: false,
  prefill: null,
  open: (prefill) => set({ isOpen: true, prefill: prefill ?? null }),
  close: () => set({ isOpen: false, prefill: null }),
}));
